(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fWbcT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf; }, function (v) { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b9a4f744ab95abc4$export$f7ad0328861e2f03; }, function (v) { return $b9a4f744ab95abc4$export$f7ad0328861e2f03 = v; });
var $b9a4f744ab95abc4$export$6503ec6e8aabbaf;
var $b9a4f744ab95abc4$export$f7ad0328861e2f03;
"use strict";
var $b9a4f744ab95abc4$var$mapping = new Map();
function $b9a4f744ab95abc4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b9a4f744ab95abc4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b9a4f744ab95abc4$var$resolve(id) {
    var resolved = $b9a4f744ab95abc4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b9a4f744ab95abc4$export$6503ec6e8aabbaf = $b9a4f744ab95abc4$var$register;
$b9a4f744ab95abc4$export$f7ad0328861e2f03 = $b9a4f744ab95abc4$var$resolve;

});

parcelRegister("dOGL2", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a0f11cae5038e8ee$export$bdfd709ae4826697; }, function (v) { return $a0f11cae5038e8ee$export$bdfd709ae4826697 = v; });
var $a0f11cae5038e8ee$export$bdfd709ae4826697;
var $a0f11cae5038e8ee$export$c9e73fbda7da57b6;
var $a0f11cae5038e8ee$export$5a759dc7a1cfb72a;
"use strict";
var $a0f11cae5038e8ee$var$bundleURL = {};
function $a0f11cae5038e8ee$var$getBundleURLCached(id) {
    var value = $a0f11cae5038e8ee$var$bundleURL[id];
    if (!value) {
        value = $a0f11cae5038e8ee$var$getBundleURL();
        $a0f11cae5038e8ee$var$bundleURL[id] = value;
    }
    return value;
}
function $a0f11cae5038e8ee$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a0f11cae5038e8ee$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a0f11cae5038e8ee$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a0f11cae5038e8ee$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a0f11cae5038e8ee$export$bdfd709ae4826697 = $a0f11cae5038e8ee$var$getBundleURLCached;
$a0f11cae5038e8ee$export$c9e73fbda7da57b6 = $a0f11cae5038e8ee$var$getBaseURL;
$a0f11cae5038e8ee$export$5a759dc7a1cfb72a = $a0f11cae5038e8ee$var$getOrigin;

});

parcelRegister("dyods", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("2BLIm"))((parcelRequire("fWbcT")).resolve("64yyS")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("10GuM"))
]).then(function() {
    return parcelRequire("82fsX");
});

});
parcelRegister("2BLIm", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("bzWhm", function(module, exports) {
"use strict";
var $86e02b94fb59de77$var$cachedBundles = {};
var $86e02b94fb59de77$var$cachedPreloads = {};
var $86e02b94fb59de77$var$cachedPrefetches = {};
function $86e02b94fb59de77$var$getCache(type) {
    switch(type){
        case "preload":
            return $86e02b94fb59de77$var$cachedPreloads;
        case "prefetch":
            return $86e02b94fb59de77$var$cachedPrefetches;
        default:
            return $86e02b94fb59de77$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $86e02b94fb59de77$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("gZJRp", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});


parcelRegister("4wWDB", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("1j7Ej")).then(function() {
    return parcelRequire("9nMib");
});

});

parcelRegister("8LppW", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("6eQK8")).then(function() {
    return parcelRequire("hGyV5");
});

});

parcelRegister("kghGB", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("6uz3m")).then(function() {
    return parcelRequire("5KOss");
});

});

parcelRegister("gWPXt", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("12dTl")).then(function() {
    return parcelRequire("iuPgd");
});

});

parcelRegister("aBTPA", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("eqtJv")).then(function() {
    return parcelRequire("a9V9x");
});

});

var $22af57f9fa0d5102$exports = {};


(parcelRequire("fWbcT")).register((parcelRequire("dOGL2")).getBundleURL("2iNWU"), JSON.parse('["2iNWU","as-legacy.js","10GuM","swiper.f250157e.js","64yyS","swiper.b6a596c6.css","1j7Ej","eyeAble.662e6bc9.js","6eQK8","mainNavHandler.6607b9df.js","6uz3m","ce_contact_popup.4a2acefd.js","12dTl","sectionNav.e74f12fc.js","eqtJv","blogLatestFilter.322ad4d2.js"]'));

// ====================================================================================
// Main Entry Point - Prioritized Module Loading
// ====================================================================================
var $71e8dfd9d0b8fc28$export$d680cb6eec13a7c7 = function() {
    return new Promise(function(resolve) {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });
};
var $71e8dfd9d0b8fc28$export$be1257a3a9248b22 = function() {
    return new Promise(function(resolve) {
        if ("requestIdleCallback" in window) requestIdleCallback(resolve, {
            timeout: 1000
        });
        else setTimeout(resolve, 100);
    });
};


// =========================================================================
// Cache selectors for better performance
// =========================================================================
var $765f16911476d698$var$swiper = document.querySelector(".swiper-container") || document.querySelector(".numbers-swiper");
var $765f16911476d698$var$eyeAble = document.querySelector(".btn--contrast");
var $765f16911476d698$var$mainNav = document.querySelector("#main-nav1");
var $765f16911476d698$var$contactPopupItems = document.querySelectorAll(".ctype-ce_contact_popup");
var $765f16911476d698$var$sectionNav = document.querySelector(".section-nav");
var $765f16911476d698$var$blogLatestFilters = document.querySelector(".blog-latest__filters");
// =========================================================================
// CRITICAL: Load immediately (blocking)
// =========================================================================
var $765f16911476d698$var$criticalImports = [];
// Add critical imports here
if ($765f16911476d698$var$criticalImports.length) Promise.all($765f16911476d698$var$criticalImports)["catch"](console.error);






// =========================================================================
// HIGH PRIORITY: Load after DOM ready
// =========================================================================
(0, $71e8dfd9d0b8fc28$export$d680cb6eec13a7c7)().then(function() {
    var imports = [];
    // Add high priority imports here
    if ($765f16911476d698$var$swiper) imports.push((parcelRequire("dyods")).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$eyeAble) imports.push((parcelRequire("4wWDB")).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$mainNav) imports.push((parcelRequire("8LppW")).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$contactPopupItems.length > 0) imports.push((parcelRequire("kghGB")).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$sectionNav) imports.push((parcelRequire("gWPXt")).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$blogLatestFilters) imports.push((parcelRequire("aBTPA")).then(function(m) {
        return m.init();
    }));
    if (imports.length) Promise.all(imports)["catch"](console.error);
});
// =========================================================================
// LOW PRIORITY: Load when browser is idle
// =========================================================================
(0, $71e8dfd9d0b8fc28$export$be1257a3a9248b22)().then(function() {
    var imports = [];
    // Add low priority imports here
    if (imports.length) Promise.all(imports)["catch"](console.error);
});

})();
//# sourceMappingURL=as-legacy.js.map
